import { Container, Button, Navbar as NavbarRB, Nav, Offcanvas, Badge, Tooltip, OverlayTrigger, Image } from 'react-bootstrap';
import useAuthStore from '../../stores/authStore';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher.jsx';
import { useTranslation } from "react-i18next";
import useSubscriptionStore from '../../stores/subscriptionStore';

function Navbar() {
    const { user, logout } = useAuthStore();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const { isDemo } = useSubscriptionStore();

    const handleLogout = () => {
        setShow(false);
        logout();
    };

    return (
        <NavbarRB bg="dark" data-bs-theme="dark" sticky="top" expand={false} className="bg-body-tertiary mb-3">
            <Container>
                <div className="d-flex align-items-center gap-2 cursor-pointer" onClick={() => navigate('/')}>
                    <Image src={`${process.env.PUBLIC_URL}/favicon-dark.svg`} alt="Logo RankedOne AI" style={{ width: '32px', height: '32px' }} />
                    <h2 className="mb-0">
                        {t('app.title')}
                    </h2>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <div className="d-none d-md-block">
                        {user && user.emailVerified && isDemo && (
                            <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip>{t('nav.demoTooltip')}</Tooltip>}
                            >
                                <Badge
                                    bg={false}
                                    onClick={() => navigate('/pricing')}
                                    text="light"
                                    className="cursor-pointer p-2 bg-pink"
                                >
                                    {t('nav.demo')}
                                </Badge>
                            </OverlayTrigger>
                        )}
                    </div>
                    <LanguageSwitcher />
                    {user && user.emailVerified && (
                        <NavbarRB.Toggle aria-controls="basic-navbar-nav" onClick={() => setShow(true)} />
                    )}
                </div>
                {user && user.emailVerified && (
                    <NavbarRB.Offcanvas
                        id={`basic-navbar-nav`}
                        aria-labelledby={`offcanvasNavbarLabel-expand`}
                        placement="end"
                        data-bs-theme="dark"
                        show={show}
                        onHide={() => setShow(false)}
                    >
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title id={`offcanvasNavbarLabel-expand`}>
                                <div className="d-flex align-items-center gap-2">
                                    <Image src={`${process.env.PUBLIC_URL}/favicon-dark.svg`} alt="Logo RankedOne AI" style={{ width: '22px', height: '22px' }} />
                                    <h5 className="mb-0">
                                        {t('app.title')}
                                    </h5>
                                </div>
                            </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <Nav className="justify-content-end flex-grow-1 pe-3">
                                <div className="d-block d-md-none">
                                    {isDemo && (
                                        <NavbarRB.Text>
                                            <Badge
                                                bg={false}
                                                onClick={() => { navigate('/pricing'); setShow(false); }}
                                                text="light"
                                                className="cursor-pointer p-2 bg-pink"
                                            >
                                                {t('nav.demo')}
                                            </Badge>
                                        </NavbarRB.Text>
                                    )}
                                </div>
                                <NavbarRB.Text>
                                    {t('nav.signedInAs')} : {user?.email}
                                </NavbarRB.Text>
                                <Nav.Link onClick={() => { navigate('/user/subscriptions'); setShow(false); }}>{t('nav.subscriptions')}</Nav.Link>
                                <Nav.Link onClick={() => { navigate('/user/affiliations'); setShow(false); }}>{t('nav.affiliations')}</Nav.Link>
                                <Nav.Link href="https://rankedone.io/contact/" onClick={() => { setShow(false); }}>{t('nav.question')}</Nav.Link>
                                <NavbarRB.Text>
                                    <Button variant="outline-danger" onClick={handleLogout} size="sm">
                                        {t('nav.signOut')}
                                    </Button>
                                </NavbarRB.Text>
                            </Nav>
                        </Offcanvas.Body>
                    </NavbarRB.Offcanvas>
                )}
            </Container>
        </NavbarRB>
    )
}

export default Navbar;